import { Outlet, ScrollRestoration } from 'react-router';

import { ErrorBoundary } from '../components/ErrorBoundary';
import { ReloadPageError } from '../components/ReloadPageError';

const Index = () => {
  return (
    <ErrorBoundary fallback={<ReloadPageError />}>
      <ScrollRestoration />

      <Outlet />
    </ErrorBoundary>
  );
};

export const Catch = ReloadPageError;

export default Index;
